import { FC } from 'react';
import { LocalizedEnumify } from '@mews/framework';
import { LocalizedDateTimeFromUtc, TooltippedIcon } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { IconName } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { hasSelectedMultipleReservations as hasSelectedMultipleReservationsSelector } from '../../../selectors/reservationModuleState/reservationSelection';
import { getNoteLabelEnumValue } from './utils';
import { CompactedNote } from './types';

interface NoteLabelProps {
    note: CompactedNote;
    scope: string;
    onDelete: (noteIds: string[]) => void;
}

export const NoteLabel: FC<NoteLabelProps> = ({ note, scope, onDelete }) => {
    const hasSelectedMultipleReservations = useCommanderSelector((state) =>
        hasSelectedMultipleReservationsSelector(state, { scope })
    );

    return (
        <>
            <LocalizedEnumify enumValue={getNoteLabelEnumValue(note)} />
            {hasSelectedMultipleReservations ? null : (
                <>
                    {UnicodeEntity.Comma}
                    {UnicodeEntity.NoBreakSpace}
                    <LocalizedDateTimeFromUtc utcString={note.createdUtc} />
                </>
            )}
            <TooltippedIcon value={IconName.Delete} onClick={() => onDelete(note.ids)} />
        </>
    );
};
